var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "dashboard" },
    [
      _c("ul", { staticClass: "nav nav-tabs" }, [
        _c(
          "li",
          {
            class: { active: _vm.$route.name === "RegistrationErrors" },
            attrs: { role: "presentation" }
          },
          [
            _c("router-link", { attrs: { to: "/support/errors" } }, [
              _vm._v(_vm._s(_vm.$t("support.dashboard.tabs.errors")))
            ])
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "li",
          {
            class: { active: _vm.$route.name === "RegistrationPendings" },
            attrs: { role: "presentation" }
          },
          [
            _c("router-link", { attrs: { to: "/support/pending" } }, [
              _vm._v(_vm._s(_vm.$t("support.dashboard.tabs.pendings")))
            ])
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "li",
          {
            class: { active: _vm.$route.name === "RegistrationInProgress" },
            attrs: { role: "presentation" }
          },
          [
            _c("router-link", { attrs: { to: "/support/inprogress" } }, [
              _vm._v(_vm._s(_vm.$t("support.dashboard.tabs.inprogress")))
            ])
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "li",
          {
            class: { active: _vm.$route.name === "RegistrationDuplicates" },
            attrs: { role: "presentation" }
          },
          [
            _c("router-link", { attrs: { to: "/support/duplicates" } }, [
              _vm._v(_vm._s(_vm.$t("support.dashboard.tabs.duplicates")))
            ])
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "li",
          {
            class: { active: _vm.$route.name === "RegistrationFinished" },
            attrs: { role: "presentation" }
          },
          [
            _c("router-link", { attrs: { to: "/support/finished" } }, [
              _vm._v(_vm._s(_vm.$t("support.dashboard.tabs.finished")))
            ])
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "li",
          {
            class: {
              active:
                _vm.$route.name === "Usage" ||
                _vm.$route.name === "UsageDetails"
            },
            attrs: { role: "presentation" }
          },
          [
            _c("router-link", { attrs: { to: "/support/usage" } }, [
              _vm._v(_vm._s(_vm.$t("support.dashboard.tabs.usage")))
            ])
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "li",
          {
            class: {
              active:
                _vm.$route.name === "EmailPreview" ||
                _vm.$route.name === "EmailPreviewDetails"
            },
            attrs: { role: "presentation" }
          },
          [
            _c("router-link", { attrs: { to: "/support/email" } }, [
              _vm._v(_vm._s(_vm.$t("support.dashboard.tabs.email")))
            ])
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("router-view")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-07cd4392", { render: render, staticRenderFns: staticRenderFns })
  }
}